import Vue from 'vue';
import Vuex from 'vuex';

import auth from './auth';
import user from './user';
import asset from './asset';
import filter from './filter';
import landmark from './landmark';
import notificationInbox from './notificationInbox';
import theme from './theme';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    remountKey: 0,
  },
  mutations: {
    INCREMENT_REMOUNT_KEY(state) {
      state.remountKey += 1;
    },
  },
  actions: {
    triggerRemount({ commit }) {
      commit('INCREMENT_REMOUNT_KEY');
    },
  },
  modules: {
    auth,
    filter,
    user,
    asset,
    landmark,
    notificationInbox,
    theme,
  },
});
